<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mt-n2">
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="200"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3" xl="3">
        <v-skeleton-loader
          class="mx-auto"
          min-width="300"
          max-height="100"
          type="image"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'StatsSkeleton'
}
</script>
